import React from 'react';

import { Link, Text } from '@change/ds-core-ui';
import { ArrowRightFilledIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { useExploreArticlesSection } from './hooks/useExploreArticlesSection';

export const ExploreArticlesSection: React.FC = () => {
	const {
		data: { articles, displayed },
		actions: { trackArticleClick },
	} = useExploreArticlesSection();

	if (!displayed) return null;

	return (
		<div className="space-y-4">
			<Text size="small" variant="heading" fontWeight="light">
				<Translate value="corgi.petition_guides_article.page_body.sidebar.explore_articles_section.title" />
			</Text>

			<div className="-ml-1 flex flex-col gap-2">
				{articles.map((article) => (
					<Link
						key={article.slug}
						leadingIcon={<ArrowRightFilledIcon />}
						data-qa={`${article.slug}-sidebar-link`}
						href={`/petition-guides/${encodeURIComponent(article.slug)}?source_location=${article.slug}-article`}
						onClick={trackArticleClick}
					>
						{article.headingShort}
					</Link>
				))}
			</div>
		</div>
	);
};
